import notifyingAction from "domainActions/notifyingAction";
import { addWatchlistEntries, removeWatchlistEntries, resolveWatchlistIdByType } from "../hooks/useWatchlistsV2";
const addEntry = (watchlistFieldType, value) => resolveWatchlistIdByType(watchlistFieldType).then((id) => addWatchlistEntries(id, [value]));
const removeEntry = (watchlistFieldType, value) => resolveWatchlistIdByType(watchlistFieldType).then((id) => removeWatchlistEntries(id, [value]));
const deleteAction = notifyingAction({
  action: removeEntry,
  success: (_watchlistFieldType, value) => ({
    message: `Field value "${value}" was removed from watchlist successfully`
  }),
  error: (error, _watchlistFieldType, value) => ({
    message: `Removing field value "${value}" from watchlist failed with status: ${error}`
  })
});
const update = notifyingAction({
  action: addEntry,
  success: (_watchlistFieldType, value) => ({
    message: `Field value "${value}" was added to watchlist successfully`
  }),
  error: (error, _watchlistFieldType, value) => ({
    message: `Adding field value "${value}" to watchlist failed with status: ${error}`
  })
});
export default {
  update,
  delete: deleteAction
};
